<template>
    <div>
        <HeaderMenu></HeaderMenu>

        <div class="main_content digital-health-solutions">
          <section class="bread_crumb">
            <div class="container">
              <ul>
                <li>
                  <router-link v-bind:to="'/'">Home</router-link>
                </li>
                <li>Digital Health Solutions</li>
              </ul>
            </div>
          </section>
          <div class="about-us digital_health_banner custom-banner-section">
            <div class="row m-0">
              <div class="col-md-6 p-0">
                <div class="about_main_image" >
                  <img src="../../assets/images/digital-healthcare.png" alt="digital-healthcare" />

                  <div class="about_main_title">
                    <h4>DIGITAL HEALTHCARE<br>SOLUTIONS</h4>
                  </div>
                </div>
              </div>
              <div class="col-md-6 p-0">

              </div>
            </div>
          </div>
          <div class="about_content_wrapper">
            <div class="container">
              <div class="about_content_block">
                <p>With the rise of value-based delivery models and
                  consumer-centric health, the future of health care
                  lies in the patients it serves. A focus on efficient
                  quality of care is where the industry needs to be
                  going. Nama provides through its partners from
                  UK, USA, and India the best IT solutions for various
                  clinical and non-clinical applications. Furthermore,
                  Nama invests in digital health by developing new
                  solutions built by Saudi medical practitioners while
                  technically supported by leading IT corporates to
                  present cost-effective alternatives to the current
                  expensive solutions. With Nama, small and
                  medium size healthcare facilities and homecare
                  practices can find the balance between quality and
                  cost and have access to top-notch clinical
                  operating technologies they need to stay
                  prosperous and competitive.</p>
              </div>
            </div>
          </div>
          <div id="radar-section" class="about-us digital_health_banner sub_banner custom-banner-section">
            <div class="row m-0">
              <div class="col-md-12 p-0">
                <div class="about_main_image">
                  <img src="../../assets/images/digital-health-solutions-radar.jpg" alt="digital-healthcare" />

                  <div class="about_main_title light d-flex align-items-center">
                    <div>
                    <a href="https://radarhealthcare.com/about-us/" target="_blank">
                      <img src="../../assets/images/radar-img.png">
                    </a>
                    </div>
                    <h4>Radar Healthcare Solutions</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container mt-5">
            <div class="row">
              <div class="col-md-12">
                <p>Radar is multiple solutions in one uses artificial intelligence and machine learning (AI/ML). includes:</p>
                <ul class="list-style-disc pl-4">
                  <li>Incident & Event management system</li>
                  <li>Risk management</li>
                  <li>Quality Audit system</li>
                  <li>Health Polices & Document management</li>
                  <li>Workforce Compliance</li>
                  <li>Alert & Announcement system</li>
                  <li>Actions & Improvement plans</li>
                  <li>Business Analytics & future predictions</li>
                </ul>
                <p>Radar Healthcare was founded by Paul Johnson and Lee Williams in 2012, with a vision of making healthcare safer. Partnering with public
                  and private organisations across health and social care, we have developed a system that supports quality improvement through monitoring risk, quality, and compliance. Today multiple tertiary care hospitals and centres of excellence in UK,
                  USA, UAE, and recently Kingdome of Saudi Arabia decided to go with Radar with our %100 retention rate.</p>
                <p>Going with Saudi vision 2030, Nama Medical is collaborating with Smartgate, Leeds, UK to enhance the experience of Saudi healthcare
                  hospitals and practitioners and have all healthcare quality and patient safety requirements and more under one umbrella. Further innovations
                  and more developments are expected in 2023.</p>
              </div>

              <div class="col-md-12">
                <div class="table-wrapper dark" cellpadding="12px">
                <table>
                  <tr>
                    <th>Radar Modules</th>
                    <th>Functionalities</th>
                  </tr>
                  <tr>
                    <td>Incident / Event Management </td>
                    <td>
                      <ul>
                        <li>Pt’ experience / complaint system (Arabic and English)</li>
                        <li>Incident Reporting System includes M&M</li>
                        <li>Event management (can be used for successful stories and experiences)</li>
                        <li>E triggers</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Risk Management</td>
                    <td>
                      <ul>
                        <li>Identify, track, and manage threats</li>
                        <li>Fully configurable risk registers and integrated “action plans” </li>
                        <li>Improve compliance and performance</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Document Management</td>
                    <td>
                      <ul>
                        <li>Uploading previous/ existing policies and determining their suggested review due date. </li>
                        <li>Plan, ratify, approve, and circulate new policies</li>
                        <li>Scheduling the reviews through document calendar</li>
                        <li>Receiving and approval feedback through emails after circulating</li>
                        <li>Create Health Policy Library</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Audit Management
                    </td>
                    <td>
                      <ul>
                        <li>Unlimited applications in clinical and non-clinical uses</li>
                        <li>Improve governance, compliance, and readiness</li>
                        <li>Can work off-line (in remote areas) and in portable devices</li>
                        <li>Can accommodate attached documents & photos</li>
                        <li>Event can trigger an audit automatically</li>
                        <li>Scheduling and due dates using Radar calendar connected to emails/ SMS</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Workforce Compliance</td>
                    <td>
                      <ul>
                        <li>Staff qualifications and training monitor</li>
                        <li>Staff compliance with policies and notifications</li>
                        <li>Coordinate staff training, and privileges </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Action & Improvement Plans</td>
                    <td>
                      <ul>
                        <li>Fully integrated and can be automated according to events, compliant, audit, or other Radar feeds</li>
                        <li>Improve existing relevant polices </li>
                        <li>Can integrate with different sections or depts at once and encourage accountability</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Business Analytics</td>
                    <td>
                      <ul>
                        <li>Variable configurable dashboards for distinct levels</li>
                        <li>Observe and manage performance of separate locations and various tasks</li>
                        <li>“Pulse” tracking features for unlimited KPIs</li>
                        <li>Trend and future prediction using AI/ML </li>
                        <li>Provide all necessary statistics </li>
                      </ul>
                    </td>
                  </tr>
                </table>

                </div>
                <h3 class="text-center mt-5 mb-4 primary-color">Installation can be on-premise or cloud-based</h3>
                <p class="text-center mb-4"><router-link v-bind:to="'/contact-us/'" class="btn large">Book a Demo</router-link></p>
              </div>
            </div>
          </div>
          <div id="his-section" class="about-us digital_health_banner sub_banner custom-banner-section border-radius-top">
            <div class="row m-0">
              <div class="col-md-12 p-0">
                <div class="about_main_image" id="about_main_image_block">
                  <img src="../../assets/images/digital-health-solutions-his-1.png" alt="digital-healthcare" />
                  <div class="about_main_title light d-flex align-items-center">
                    <div>
                    <a href="https://namamedical.org/" target="_blank"><img src="../../assets/images/image1.png"></a>
                    </div>
                    <h4>Nama Hospital Information System</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="container-fluid light-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center"><p>About</p> NAMA HIS</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid dark-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                 <p>NAMA HIS is a comprehensive, web-based Hospital Information System designed to improve hospital efficiency and 
                  effectiveness. It offers robust features that enable seamless hospital operations, leading to streamlined processes and increased customer satisfaction. 
                  The system emphasizes customization and adaptation to meet specific hospital needs and requirements.</p>
                   <p>A key benefit of NAMA HIS is its ability to handle complex processes, ensure regulatory compliance, and foster organization-wide collaboration.
                    Adopting a paperless system helps hospitals achieve more efficient workflows and better resource utilization. </p>
                    <p> NAMA HIS is proven to deliver a high return on investment by managing processes and enhancing operational efficiency. 
                      It plays a crucial role in improving patient care quality and boosting the productivity of nursing and medical staff. </p>
                   
                    <p>The system offers a centralized repository for clinical, administrative, and financial information, providing healthcare professionals with accurate and current patient data. 
                      With its built-in integration technology, NAMA HIS consolidates data from various sources, reducing discrepancies and enhancing data accuracy.</p>
                </div>
              </div>
            </div>
          </div>

          

          
            
      
          


          <div class="container-fluid dark-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  
                </div>

                <div class="table-wrapper light" cellpadding="12px">
                  <table>
                    <tr>
                    <th width="50%">Modules</th>
                    
                    </tr>
                    <tr>
                      <td>
                        <ul>
                          <li style="background-color:Gray;"> Front Office Suite  </li>
                          <li>  Electronic Medical Record (EMR)  </li>
                          <li style="background-color:Gray;;"> Patient Scheduling System    </li>
                          <li> Computerized Physician Order Entry (CPOE)  </li>
                          <li style="background-color:Gray;">Admission, Discharge and Transfer</li>
                          <li>Nursing Care Management</li>
                          <li style="background-color:Gray;">Insurance Management</li>
                          <li>Operation Theatre Management</li>
                          <li style="background-color:Gray;">Medical Billing System</li>
                          <li>E-claim, E-approval & E-prescription Management</li>
                          <li style="background-color:Gray;">Lab Information System</li>
                          <li>Biomedical Equipment Integration</li>
                          <li style="background-color:Gray;">Radiology Information System</li>
                          <li>PACS Integration</li>
                          <li style="background-color:Gray;">Pharmacy Management</li>
                          <li>E&M Management</li>
                          <li style="background-color:Gray;">Dietary Management</li>
                          <li>Infection Control Management</li>
                          <li style="background-color:Gray;">Finance Management</li>
                          <li>Central Sterile Supply Department (CSSD)</li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                            <li style="background-color:Gray;"> Canteen Management  </li>
                            <li>Procurement & Inventory Management</li>
                            <li style="background-color:Gray;">Chronic Disease Management</li>
                            <li>Emergency Management</li>
                            <li style="background-color:Gray;">Clinical Pathways</li>
                            <li>Asset Management</li>
                            <li style="background-color:Gray;">Alert System & Audit Trails</li>
                            <li>Warehouse Management</li>
                            <li style="background-color:Gray;">CRM Dashboards</li>
                            <li>Equipment Contract Management</li>
                            <li style="background-color:Gray;">SMS & Email Integration</li>
                            <li>Blood Bank Management</li>
                            <li style="background-color:Gray;">Patient Journey Management</li>
                            <li>Decision Support System</li>
                            <li style="background-color:Gray;">Patient Survey and Feedback Management</li>
                            <li>Mobile Apps & Patient Portals</li>
                            <li style="background-color:Gray;">Business Intelligence Reports</li>
                            <li>Incident Management System</li>
                            <li style="background-color:Gray;"> HR with Clinical Privileging System   </li>
                        </ul>


                        <!--<h4>More:</h4>
                        <ul>
                          <li>Tele-medicine</li>
                          <li>Home-care</li>
                        </ul>-->

                      </td>
                    </tr>
                  </table>
                </div>

                



                <ol class="mt-5 color-white">
                  <li>- Nama-HIS can be installed on prem vs cloud</li>
                  <li>- Nama-HIS cloud has high availability %99,99 and %100 secured data as per Saudi laws.</li>
                </ol>
              </div>

              <p>
                Download Brochure
            </p>
            <a href="https://drive.google.com/file/d/1jh1ylfqtFoAFlXeVviVGMdUuiTUnGB6e/view?usp=sharing" download="GFG">
                <button type="button">Download</button>
            </a>
            </div>
          </div>
          
          <div>
            
            <iframe allowfullscreen="" scrolling="no" class="fp-iframe" style="border: 1px solid lightgray; width: 100%; height: 550px;" src="https://heyzine.com/flip-book/d22199e3fa.html"></iframe>
                        
          </div>

          <div class="container-fluid light-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">Our integrated, interoperable, patient-centred EHR platform spans the continuum of care</h3>
                </div>
              </div>
            </div>
          </div>

          

          <div class="container-fluid dark-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <p>Nama-HIS is a comprehensive Hospital Information System for managing the automation needs of every segment in the healthcare environment. Engineered in a Hybrid environment, Nama-HIS can retrieve and disseminate patient-specific data (clinical and financial) across the entire health enterprise. The modules are broadly divided into Front Office, Clinical, Back Office, and additional modules and interfaces. We are proposing the latest Nama-HIS version 4, which is built on the best of breed technologies with a very user-friendly UI.</p>

                  <p>The Nama-HIS platform supports an enterprise-wide view of patient care and the point at which care is delivered in both inpatient and outpatient settings. This integration across the continuum of care enables providers to make informed, data-driven decisions without leaving the clinical workflows.</p>

                  <p>With Nama-HIS, you can share and access information among multiple facilities and across the continuum of care. Hospitals, clinics, physician offices, long-term care facilities, satellite clinics – all your locations – become connected. Nama-HIS revenue cycle
                  solutions are intimately integrated into the clinical process to enable the financial, operational, and clinical facets of your organization to work together.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid light-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">We care about Clinicians’ Experience</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid dark-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <p>Clinicians are experiencing an overwhelming feeling of frustration in their careers and a loss of professional fulfilment because of several factors ranging from loss of autonomy to decreased efficiency.</p>
                  <p>Our interoperability solutions put health information at the fingertips of clinicians, within the EHR workflow, aiming to enable clinicians to spend less time searching for information so they can spend more time with their patients. Smarter solution improves patient’s care! </p>
                  <p>Nama works through Saudi and international healthcare practitioners and consultants who keep improving our solutions
        front end preferences and expand functionalities required at the Saudi market.</p>
                  <p>Continuous improvement is a value-based, data-driven service that optimizes your experience. We assist you in getting current and staying current, aiming to help enable improved decision-making to impact efficient health care management.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid light-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">Maximum Security & Data Protection</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid dark-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <ul class="list-style">
                    <li>Nama-HIS cloud system using category 3 maximum security
         within Kingdome of Saudi Arabia, as per SDAIA regulations.</li>
                    <li>Nama-HIS on promise installation. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid light-bg">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">Nama-HIS conceptual design:</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid dark-bg radius-bottom">
            <div class="container">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <img src="../../assets/images/conceptual-design.jpg" alt="">
                </div>
                <div class="col-md-12 d-flex justify-content-center mt-5 mb-4">
                    <router-link v-bind:to="'/contact-us/'" class="btn large">Book a Demo</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'

export default{
    data(){
        return {
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods:{
    },
    mounted() {
        var target_object = $(this.$route.hash);
        console.log(target_object.offset(),"1111111111111111111");
        if(target_object.length){
          setTimeout(function(){
            console.log(target_object.offset(),"222222222222222222222222");
            $('html, body').animate({scrollTop:target_object.offset().top})
          },1000);

        }
        $(window).on('scroll',function(){
          console.log($(window).scrollTop(),"asdasd",target_object.scrollTop());
        })
    },
}
</script>

<style>
        .newcontainer {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            padding: 20px;
        }
        .module {
            background-color: #f0f0f0;
            padding: 10px;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        h2 {
            text-align: center;
        }
        @media (max-width: 768px) {
            .newcontainer {
                grid-template-columns: 1fr;
            }
        }
    </style>



// WEBPACK FOOTER //
// src/components/Pages/DigitalHealthSolutions.vue